<template>
  <div>
      <span v-html="text"></span>
  </div>
</template>

<script>
export default {
    name: 'TextComponent',
    props: {
        text: String
    }
}
</script>

<style>
    .addline {
        white-space: pre-line;
    }

    code {
        color: #6c63ff;
    }

</style>